import React, { useState } from 'react';
import TierHeader from './TierHeader';
import TierLegends from './TierLegends';
import { Collapse } from 'reactstrap';
import TierNode from './TierNode';
import { Framework, Tier4 } from 'src/shared/types/src';

const TierFour  = ({ _framework, expand }: { _framework: Framework, expand: boolean }) => {
  const [isVisible, setIsVisible] = useState(expand);
  const assessments = _framework.assessments as Tier4;

  return (
    <div className='framework-tier-wrap'>
      <TierHeader tierTitle={_framework.name} onClick={() => setIsVisible(!isVisible)} isVisible={isVisible} />
        <Collapse isOpen={isVisible}> 
          <div className='mg-t-10'>
          <TierLegends assessmentLevels={_framework.assessmentLevel} />
            <div className='mg-t-5'>
              { assessments?.areas?.map((areas: any, index: number) => 
                <TierNode content={areas.name} key={index} borderColor={areas.color} customLabelStyle={'fw-semibold'}>
                  {
                    areas?.aspects?.map((aspect: any, idx: number) => 
                      <TierNode content={aspect.name} key={index} borderColor={aspect.color} customLabelStyle={'fw-semibold'} customContainerStyle={`${aspect.color ? 'mg-t-10' : (idx === 1 ? 'mg-t-10' : 'mg-t-0')}`}>
                        {aspect.age_bands.map((ageBand: any, i: number) => 
                            <TierNode content={ageBand.name} borderColor={ageBand.color} key={`${index}-${idx}-${i}`} customLabelStyle={'fw-semibold'} customContainerStyle={`${ageBand.color ? 'mg-t-10' : (i === 1 ? 'mg-t-10' : 'mg-t-0')}`}>
                              {
                                ageBand.statements.map((statement: any, j: number) => 
                                  <TierNode content={statement.name} label={statement.label} iconType={statement.iconType} borderColor={statement.color} key={`${index}-${idx}-${i}-${j}`} isStatement={true} />
                                )
                              }
                            </TierNode>
                          )
                        }
                      </TierNode>
                    )
                  }
                </TierNode>
              )}
            </div>
          </div>
        </Collapse>
    </div>
  );
};

export default TierFour;
